import axios from 'axios';
import { router as enRouter } from '@/router/en/index';
import { router as ruRouter } from '@/router/ru/index';
import config from '@/config';
import { localeStore } from './locale';

export const createHttpClient = () => {
  const token = window.localStorage.getItem('token');
  const client = axios.create({
    headers: {
      Accept: 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
  });

  // Резолвим baseURL на каждый запрос: httpClient создаётся при импорте модуля,
  // а локаль домена выставляется позже в main.js (localeStore.setLang).
  // Если зафиксировать baseURL здесь, на RU-домене он застынет на дефолтном 'en'.
  client.interceptors.request.use((requestConfig) => {
    requestConfig.baseURL = config.apiURL[localeStore.lang];
    return requestConfig;
  });

  const getRouterByDomain = () => (localeStore.lang === 'ru' ? ruRouter : enRouter);

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      // Фоновые запросы (аналитика) не должны уводить пользователя со страницы:
      // иначе, например, ещё не выкаченная ручка отправит весь трафик на 404.
      if (error.config?.skipErrorRedirect) {
        throw error;
      }

      const router = getRouterByDomain();

      if (error.response && error.response.status === 500) {
        router.push({ name: 'server-error' });
      }
      if (error.response && error.response.status === 404) {
        router.push({ name: 'not-found' });
      }

      throw error;
    },
  );

  return client;
};

export const httpClient = createHttpClient();
